import React from 'react';
import { useLocation } from 'react-router-dom';
import { quickBooksEntryAction } from './utils/quickbooksEntry';

const QuickBooksEntryPage = React.lazy(() => import('./pages/integrations/QuickBooksEntry'));

// Keep Intuit entry links out of the normal application's legacy login redirects.
const QuickBooksEntryGate = ({
  children,
  runtimeEnvironment,
}) => {
  const { pathname } = useLocation();
  const action = quickBooksEntryAction(pathname);
  if (!action) return children;
  return <QuickBooksEntryPage key={action} action={action} domain={runtimeEnvironment.REACT_APP_DOMAIN} />;
};

export default QuickBooksEntryGate;
